import { create } from 'zustand';
import { useAlertStore } from './use-alert-store';
import {
  deleteQrTemplates,
  fetchQrTemplates,
  postQrTemplates,
  putQrTemplates,
  QrTemplateType,
} from './api/qr-templates-api';
import { DefaultRequest } from '../types/props';

interface Store {
  templates?: QrTemplateType[];
  fetchTemplates: (params?: DefaultRequest) => Promise<void>;
  postTemplate: (data: Partial<QrTemplateType>) => Promise<void>;
  putTemplate: (data: Partial<QrTemplateType>) => Promise<void>;
  deleteTemplate: (id: string) => Promise<void>;
  isLoading?: boolean;
  isLoadingFetch?: boolean;
  template?: Partial<QrTemplateType>;
  handleUpdateTemplate: (data?: Partial<QrTemplateType>) => void;
  handleResetTemplate: () => void;
}

export const useQrTemplatesStore = create<Store>((set, get) => ({
  handleUpdateTemplate: (data) => {
    set((store) => ({ ...store, template: { ...store.template, ...data } }));
  },
  handleResetTemplate: () => set({ template: undefined }),
  fetchTemplates: async (params) => {
    set({ isLoadingFetch: true });
    try {
      const resp = await fetchQrTemplates(params);
      set({ templates: resp });
    } catch (e) {
      console.error(e);
      useAlertStore
        .getState()
        .add({ label: 'Не удалось получить данные по QR шаблонам', variant: 'danger' });
    } finally {
      set({ isLoadingFetch: false });
    }
  },
  postTemplate: async (data) => {
    set({ isLoading: true });
    try {
      const resp = await postQrTemplates(data);
      set({ templates: [resp, ...(get().templates || [])] });
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось создать QR шаблон', variant: 'danger' });
      throw e;
    } finally {
      set({ isLoading: false });
    }
  },
  putTemplate: async (data) => {
    set({ isLoading: true });
    try {
      const resp = await putQrTemplates(data);
      set({ templates: get().templates?.map((item) => (item.id === resp.id ? resp : item)) });
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось обновить QR шаблон', variant: 'danger' });
      throw e;
    } finally {
      set({ isLoading: false });
    }
  },
  deleteTemplate: async (id) => {
    set({ isLoading: true });
    try {
      await deleteQrTemplates(id);
      set({ templates: get().templates?.filter((item) => item.id !== id) });
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось удалить QR шаблон', variant: 'danger' });
      throw e;
    } finally {
      set({ isLoading: false });
    }
  },
}));
